export default __webpack_public_path__ + "d3c6cc0aa4bd49103d9b8bd60c830893.png";